import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=666be432&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=666be432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666be432",
  null
  
)

export default component.exports